/* eslint-disable @typescript-eslint/no-explicit-any */
import Mapper from './Mapper'
import { IShortCourseTag, IShortCourseLanding, IShortCourseCoach, IShortCourse, IShortCourseFilters, IShortCourseSearchResponse } from '@web/store/types/modules/shortCourse'

class ShortCourseMapper {
  /**
   * Преобразование категории курса
   */
  static mapTag (tag: Record<string, any> | null): IShortCourseTag | null {
    if (!tag) return null

    return Mapper.converter({
      data: tag,
      rules: {}
    }) as IShortCourseTag | null
  }

  /**
   * Преобразование landing информации
   */
  static mapLanding (landing: Record<string, any> | null): IShortCourseLanding | null {
    if (!landing) return null

    return Mapper.converter({
      data: landing,
      rules: {}
    }) as IShortCourseLanding | null
  }

  /**
   * Преобразование информации о тренере
   */
  static mapCoach (coach: Record<string, any> | null): IShortCourseCoach | null {
    if (!coach) return null

    return Mapper.converter({
      data: coach,
      rules: {
        photo: {
          baseUrl: true
        }
      }
    }) as IShortCourseCoach | null
  }

  /**
   * Преобразование одного курса с сервера на клиент
   */
  static mapCourse (data: Record<string, any>): IShortCourse {
    return Mapper.converter({
      data,
      rules: {
        thumbnail: {
          rename: 'backgroundImage'
          // baseUrl: true
        },
        // backgroundImage: {
        //   baseUrl: true
        // },
        tags: {
          cb: (tags: Record<string, any>[]) =>
            tags.map(tag => ShortCourseMapper.mapTag(tag))
        },
        landing: {
          cb: (value) => ShortCourseMapper.mapLanding(value)
        },
        coach: {
          cb: (value) => ShortCourseMapper.mapCoach(value)
        }
      }
    }) as IShortCourse
  }

  /**
   * Преобразование фильтров
   */
  static mapFilters (data: Record<string, any>): IShortCourseFilters {
    return Mapper.converter({
      data,
      rules: {
        tags: {
          cb: (tags: Record<string, any>[]) =>
            tags.map(tag => ShortCourseMapper.mapTag(tag))
        }
      },
      defaults: {
        tags: []
      }
    }) as IShortCourseFilters
  }

  /**
   * Преобразование полного ответа поиска курсов
   */
  static toClient (data: Record<string, any>): IShortCourseSearchResponse {
    return {
      courses: (data.courses || []).map((course: Record<string, any>) =>
        ShortCourseMapper.mapCourse(course)
      ),
      filters: ShortCourseMapper.mapFilters(data.filters || { categories: [] })
    }
  }
}

export default ShortCourseMapper
